/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RouteLeg
 */
export interface RouteLeg {
  /**
   *
   * @type {number}
   * @memberof RouteLeg
   */
  distanceMeters: number;
  /**
   *
   * @type {number}
   * @memberof RouteLeg
   */
  durationSeconds: number;
}

/**
 * Check if a given object implements the RouteLeg interface.
 */
export function instanceOfRouteLeg(value: object): value is RouteLeg {
  if (!("distanceMeters" in value) || value["distanceMeters"] === undefined)
    return false;
  if (!("durationSeconds" in value) || value["durationSeconds"] === undefined)
    return false;
  return true;
}

export function RouteLegFromJSON(json: any): RouteLeg {
  return RouteLegFromJSONTyped(json, false);
}

export function RouteLegFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RouteLeg {
  if (json == null) {
    return json;
  }
  return {
    distanceMeters: json["distanceMeters"],
    durationSeconds: json["durationSeconds"],
  };
}

export function RouteLegToJSON(json: any): RouteLeg {
  return RouteLegToJSONTyped(json, false);
}

export function RouteLegToJSONTyped(
  value?: RouteLeg | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    distanceMeters: value["distanceMeters"],
    durationSeconds: value["durationSeconds"],
  };
}
